import axios from "axios";

const prepareData = (data) => {return {drawing_office_work_package_status:data}}

// Plural Actions
export const GET_DRAWING_OFFICE_WORK_PACKAGE_STATUSES = "get_drawing_office_work_package_statuses";
export const getDrawingOfficeWorkPackageStatuses = () => {
	const url = `/drawing_office/work_package_statuses.json`
	const request = axios.get(url);
	return {
		type: GET_DRAWING_OFFICE_WORK_PACKAGE_STATUSES,
		payload: request
	};
};


// Singular Actions
export const CREATE_DRAWING_OFFICE_WORK_PACKAGE_STATUS = "create_drawing_office_work_package_status";
export const createDrawingOfficeWorkPackageStatus = (data) => {
	const url = `/drawing_office/work_package_statuses.json`
	const request = axios({method: "post",url: url,data: prepareData(data)});
	return {
		type: CREATE_DRAWING_OFFICE_WORK_PACKAGE_STATUS,
		payload: request
	};
};

export const GET_DRAWING_OFFICE_WORK_PACKAGE_STATUS = "get_drawing_office_work_package_status";
export const getDrawingOfficeWorkPackageStatus = (id) => {
	const url = `/drawing_office/work_package_statuses/${id}.json`
	const request = axios.get(url);
	return {
		type: GET_DRAWING_OFFICE_WORK_PACKAGE_STATUS,
		payload: request
	};
};

export const UPDATE_DRAWING_OFFICE_WORK_PACKAGE_STATUS = "update_drawing_office_work_package_status";
export const updateDrawingOfficeWorkPackageStatus = (id,data) => {
	const url = `/drawing_office/work_package_statuses/${id}.json`
	const request = axios({method: "patch",url: url,data: prepareData(data)});
	return {
		type: UPDATE_DRAWING_OFFICE_WORK_PACKAGE_STATUS,
		payload: request
	};
};

export const DESTROY_DRAWING_OFFICE_WORK_PACKAGE_STATUS = "destroy_drawing_office_work_package_status";
export const destroyDrawingOfficeWorkPackageStatus = (id) => {
	const url = `/drawing_office/work_package_statuses/${id}.json`
	const request = axios({method: "delete",url: url});
	return {
		type: DESTROY_DRAWING_OFFICE_WORK_PACKAGE_STATUS,
		payload: request
	};
};
